/* eslint-disable no-undef */
class GrapheneHCCarousel extends window.BAO.CustomElement() {
  connectedCallback () {
    const carouselOptions = this.closest(
      '[data-graphenehc-carousel-desktop-slide-count]'
    )
    this.carousel = this.setupCarousel(carouselOptions)
  }

  setupCarousel (carouselOptions) {
    const desktopCount = carouselOptions
      ? Number(
        carouselOptions.getAttribute(
          'data-graphenehc-carousel-desktop-slide-count'
        )
      )
      : 5

    return new window.KeenSlider(
      this.els.slides.element,
      {
        selector: this.els.slide.selector,
        defaultAnimation: {
          duration: 1500
        },
        loop: true,
        mode: 'snap',
        slides: { origin: 'center', perView: 1.5, spacing: 10 },
        breakpoints: {
          '(min-width: 601px)': {
            slides: { origin: 'center', perView: 2.5, spacing: 20 }
          },
          '(min-width: 1201px)': {
            slides: {
              perView: desktopCount,
              spacing: 30
            }
          }
        }
      },
      [
        window.BAO.carousel.useInitialised(),
        window.BAO.carousel.useArrows({
          next: this.els?.next?.element,
          previous: this.els?.previous?.element
        })
      ]
    )
  }
}

if (!customElements.get('graphenehc-carousel')) {
  customElements.define('graphenehc-carousel', GrapheneHCCarousel)
}
